'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002ecollection$002econvert$002e$002dJava$002dCollection$002dWrappers$0024$002dIterator$002dWrapper from "./scala.collection.convert.-Java-Collection-Wrappers$-Iterator-Wrapper.js";
import * as $j_scala$002ecollection$002econvert$002e$002dJava$002dCollection$002dWrappers$0024$002dJ$002dIterator$002dWrapper from "./scala.collection.convert.-Java-Collection-Wrappers$-J-Iterator-Wrapper.js";
import * as $j_scala$002ecollection$002econvert$002e$002dJava$002dCollection$002dWrappers$0024$002dMutable$002dSet$002dWrapper from "./scala.collection.convert.-Java-Collection-Wrappers$-Mutable-Set-Wrapper.js";
import * as $j_scala$002ejdk$002e$002dCollection$002dConverters$0024 from "./scala.jdk.-Collection-Converters$.js";
import * as $j_scala$002ejdk$002ejavaapi$002e$002dCollection$002dConverters$0024 from "./scala.jdk.javaapi.-Collection-Converters$.js";
var $p;
function $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator($thiz, i) {
  return ((i === null) ? null : (false ? i.YW() : new $j_scala$002ecollection$002econvert$002e$002dJava$002dCollection$002dWrappers$0024$002dJ$002dIterator$002dWrapper.$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(i)));
}
export { $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator as $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator };
function $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set($thiz, s) {
  return ((s === null) ? null : (false ? s.YX() : new $c_sc_convert_JavaCollectionWrappers$JSetWrapper(s)));
}
export { $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set as $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set };
/** @constructor */
function $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(outer, i) {
  this.MV = null;
  this.MV = i;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
}
export { $c_sc_convert_AsScalaExtensions$IteratorHasAsScala as $c_sc_convert_AsScalaExtensions$IteratorHasAsScala };
$p = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$IteratorHasAsScala() {
}
export { $h_sc_convert_AsScalaExtensions$IteratorHasAsScala as $h_sc_convert_AsScalaExtensions$IteratorHasAsScala };
$h_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = $p;
$p.Su = (function() {
  return $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator($j_scala$002ejdk$002ejavaapi$002e$002dCollection$002dConverters$0024.$m_s_jdk_javaapi_CollectionConverters$(), this.MV);
});
var $d_sc_convert_AsScalaExtensions$IteratorHasAsScala = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_AsScalaExtensions$IteratorHasAsScala, "scala.collection.convert.AsScalaExtensions$IteratorHasAsScala", ({
  sO: 1
}));
export { $d_sc_convert_AsScalaExtensions$IteratorHasAsScala as $d_sc_convert_AsScalaExtensions$IteratorHasAsScala };
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JSetWrapper(underlying) {
  this.iZ = null;
  this.iZ = underlying;
}
export { $c_sc_convert_JavaCollectionWrappers$JSetWrapper as $c_sc_convert_JavaCollectionWrappers$JSetWrapper };
$p = $c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = new $j_java$002elang$002e$002dObject.$h_scm_AbstractSet();
$p.constructor = $c_sc_convert_JavaCollectionWrappers$JSetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JSetWrapper() {
}
export { $h_sc_convert_JavaCollectionWrappers$JSetWrapper as $h_sc_convert_JavaCollectionWrappers$JSetWrapper };
$h_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = $p;
$p.a7 = (function(f) {
  return $j_java$002elang$002e$002dObject.$f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$p.bH = (function(that) {
  return $j_java$002elang$002e$002dObject.$f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O(this, that);
});
$p.T = (function() {
  return this.iZ.T();
});
$p.k = (function() {
  return this.iZ.k();
});
$p.P = (function() {
  return (this.iZ.k() ? 0 : (-1));
});
$p.s = (function() {
  return new $c_sc_convert_AsScalaExtensions$IteratorHasAsScala($j_scala$002ejdk$002e$002dCollection$002dConverters$0024.$m_s_jdk_CollectionConverters$(), this.iZ.cV()).Su();
});
$p.ae = (function(elem) {
  return this.iZ.ae(elem);
});
$p.S1 = (function(elem) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
$p.la = (function(elem) {
  return this.iZ.la(elem);
});
$p.b7 = (function() {
  return $j_java$002elang$002e$002dObject.$m_scm_HashSet$();
});
$p.aG = (function(elem) {
  return this.S1(elem);
});
function $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.fc)));
}
export { $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper as $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper };
var $d_sc_convert_JavaCollectionWrappers$JSetWrapper = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_JavaCollectionWrappers$JSetWrapper, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper", ({
  fc: 1,
  cy: 1,
  am: 1,
  s: 1,
  h: 1,
  i: 1,
  r: 1,
  q: 1,
  p: 1,
  o: 1,
  an: 1,
  b: 1,
  a9: 1,
  a0: 1,
  J: 1,
  Z: 1,
  O: 1,
  P: 1,
  V: 1,
  b7: 1,
  cE: 1,
  bF: 1,
  w: 1,
  fa: 1,
  a: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$JSetWrapper as $d_sc_convert_JavaCollectionWrappers$JSetWrapper };
